import React, { useEffect, useState } from "react";
import "./App.css";
import "./common/antd-custom.css"
import { useCookies, CookiesProvider } from "react-cookie";
import { isMobile } from "react-device-detect";
import BaseScreen from './common/components/BasicUI/BaseScreen';
import BaseDialog from './common/components/BasicUI/BaseDialog'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { UserReducer } from './common/hook/UserHook';
import { DialogContext, AppContext, UserContext } from "./common/AppContext";
import SC01_HomeScreen from "./screens/SC01_HomeScreen";
import * as PATH from './common/constant/path'

import BaseCMSLayout from "./common/components/BasicUI/BaseCMSLayout";
import SC02_GameConfig from "./screens/SC02_GameConfig";
import SC03_Customer from "./screens/SC03_Customer";
import SC04_ImportUser from "./screens/SC04_ImportUser";
import SC05_School from "./screens/SC05_School";
import SC06_Export from "./screens/SC06_Export";

import PrivacyPage from "./screens/PrivacyPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

function App() {
  const [appConfig, setAppConfig] = useState({})
  const [dialogData, setDialogData] = useState({ visible: false })
  const userReducer = UserReducer();

  const [cookies, setCookie, removeCookie] = useCookies(["user"]);

  const showDialog = (message, params) => {
    let content = { visible: true, message: message };
    if (params)
      content = { ...content, ...params }
    setDialogData(content)
  }

  const hideDialog = () => {
    setDialogData({ visible: false });
  }

  return (
    // <ErrorBoundary>
    <CookiesProvider>

      <Router>
        <DialogContext.Provider value={{ dialogData, showDialog, hideDialog }}>
          <AppContext.Provider value={{ appConfig, setAppConfig }}>
            <UserContext.Provider value={userReducer}>
              <BaseScreen>
                <BaseCMSLayout>
                  <Routes>
                    <Route path='/' exact element={<SC01_HomeScreen />} />
                    <Route path={PATH.CONFIG} exact element={<SC02_GameConfig />} />
                    <Route path={PATH.CUSTOMER} exact element={<SC03_Customer />} />
                    <Route path={PATH.IMPORT} exact element={<SC04_ImportUser />} />
                    <Route path={PATH.SCHOOL} exact element={<SC05_School />} />
                    <Route path={PATH.EXPORT} exact element={<SC06_Export />} />
                    <Route path={PATH.PRIVACY} exact element={<PrivacyPage />} />
                  </Routes>
                </BaseCMSLayout>
                <BaseDialog />
              </BaseScreen>
            </UserContext.Provider>
          </AppContext.Provider>
        </DialogContext.Provider>

      </Router>
    </CookiesProvider>
    // </ErrorBoundary>
  );
}

export default App;
